var _style, _circle, _path, _path2, _path3, _path4, _path5, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_);}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000055681889933294862240000005462682337455613345_);}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#FC9965;}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#FF2D55;}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000025415687210289849430000012940457608752476349_);}\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#FFBC5B;}\n\t.st7{fill-rule:evenodd;clip-rule:evenodd;fill:#FFC95B;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -68.574,
    y1: 825.4679,
    x2: -70.1318,
    y2: 823.9101,
    gradientTransform: "matrix(400 0 0 -400 28181.4883 330316.625)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2D55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFBC5B"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 440.3,
    cy: 441.1,
    r: 440.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109711930570126607260000008003923500312097941_",
    gradientUnits: "userSpaceOnUse",
    x1: -67.6022,
    y1: 824.9862,
    x2: -67.6022,
    y2: 822.7832,
    gradientTransform: "matrix(125 0 0 -150 8899.8564 124034.7734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A524B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF2D55"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000109711930570126607260000008003923500312097941_)"
    },
    d: " M311.9,286.8v330.5h275.4L311.9,286.8z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M36.5,617.3h275.4V286.8L36.5,617.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M87.8,705.4c25.1,33.3,54.9,63,88.1,88.1h528.7c33.3-25.1,63-54.9,88.1-88.1H87.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M176,793.5c73.6,55.3,165.2,88.1,264.4,88.1s190.8-32.8,264.4-88.1H176z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023243316841790202490000016032419881835286689_",
    gradientUnits: "userSpaceOnUse",
    x1: -65.2417,
    y1: 823.8708,
    x2: -65.2417,
    y2: 821.6678,
    gradientTransform: "matrix(91.7 0 0 -110 6674.4678 91088.8672)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A524B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF2D55"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000023243316841790202490000016032419881835286689_)"
    },
    d: " M590.8,463.1v242.3h202L590.8,463.1z"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M590.8,617.3H36.5c13.7,31.5,31.1,61,51.3,88.1H591v-88.1H590.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M389,705.4h201.8V463.1L389,705.4z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 590.8,
    cy: 286.8,
    r: 110.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 311.9,
    cy: 165.7,
    r: 55.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManaIcon);
export default __webpack_public_path__ + "static/media/mana_icon.b44ae41e41b979673d3836b68b173448.svg";
export { ForwardRef as ReactComponent };